<template>
  <div id="RequestLetterTaghirModatSepordeh" class="bnp-tm" dir="rtl">
    <panel
      Title="درخواست تغییر مدت سپرده"
      Des="از طریق این فرم می‌توانید درخواست تغییر مدت سپرده یا دریافت تسهیلات در تاریخ مشخص را برای مدیر سامانه ارسال کنید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-tab :Tabs="RequestTabs" :Active="activeTab" @change="onTabChange"></net-pa-tab>
        <div class="tab-content">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-tm-form' }"
            id="nav-tm-form"
            role="tabpanel"
            aria-labelledby="nav-tm-form-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <!-- درخواست در حال بررسی -->
                <div v-if="HasPendingRequest" class="bnp-tm-pending" role="status">
                  <i class="fas fa-hourglass-half bnp-tm-pending__icon" aria-hidden="true"></i>
                  <div class="bnp-tm-pending__body">
                    <div class="bnp-tm-pending__title">
                      درخواست شما در حال بررسی است
                      <span class="bnp-tm-badge bnp-tm-badge--warning">در حال بررسی</span>
                    </div>
                    <p class="bnp-tm-pending__text">
                      عضو محترم، درخواست تغییر مدت سپرده شما در تاریخ <b dir="ltr">{{ zamanInsert }}</b> ارسال شده است. تا زمان تعیین وضعیت توسط مدیر سامانه، امکان ارسال درخواست جدید وجود ندارد.
                    </p>
                  </div>
                </div>

                <!-- فرم نامه -->
                <div v-else class="bnp-tm-form">
                  <header class="bnp-tm-letter-head">
                    <span class="bnp-tm-eyebrow">{{ $store.state.NameSandogh }}</span>
                    <h5 class="bnp-tm-letter-title">فرم درخواست تغییر مدت سپرده</h5>
                  </header>

                  <div class="bnp-tm-salutation">
                    <p class="bnp-tm-salutation__to">مدیرعامل محترم شرکت تعاونی اعتبار</p>
                    <p>با سلام</p>
                    <p>احتراماً، خواهشمند است دستور فرمایید نسبت به درخواست زیر اقدامات لازم مبذول گردد.</p>
                  </div>

                  <dl class="bnp-tm-tiles">
                    <div class="bnp-tm-tile">
                      <dt>درخواست‌کننده</dt>
                      <dd>{{ NamFam || '—' }}</dd>
                    </div>
                    <div class="bnp-tm-tile">
                      <dt>کد ملی</dt>
                      <dd dir="ltr" class="bnp-tm-ltr">{{ CodeMeli || '—' }}</dd>
                    </div>
                  </dl>

                  <div class="bnp-tm-section-title">
                    <i class="fas fa-list-ul" aria-hidden="true"></i>
                    نوع درخواست را انتخاب کنید
                  </div>

                  <div class="bnp-tm-options" role="radiogroup" aria-label="نوع درخواست">
                    <!-- گزینه ۱: تغییر مدت سپرده -->
                    <div class="bnp-tm-option" :class="{ 'bnp-tm-option--active': IsSaveEmtiaz == 1 }" @click="IsSaveEmtiaz = 1">
                      <label class="bnp-tm-option__head" for="tmOption1">
                        <input id="tmOption1" type="radio" name="tmRequestType" class="bnp-tm-radio" :value="1" v-model="IsSaveEmtiaz" />
                        <span class="bnp-tm-option__title">تغییر مدت سپرده‌گذاری</span>
                      </label>
                      <p class="bnp-tm-option__desc">
                        اینجانب <b>{{ NamFam }}</b> با کد ملی <b dir="ltr">{{ CodeMeli }}</b> درخواست تغییر مدت سپرده‌گذاری از
                        <b>{{ AzMah || '...' }}</b> ماه به <b>{{ BeMah || '...' }}</b> ماه و با مدت بازپرداخت
                        <b>{{ ModatBazPardakht || '...' }}</b> ماه را دارم.
                      </p>
                      <div class="bnp-tm-grid">
                        <div class="bnp-tm-field">
                          <label for="tmAzMah" class="bnp-tm-label">از ماه</label>
                          <div class="bnp-tm-unit-wrap">
                            <input
                              id="tmAzMah"
                              v-model="AzMah"
                              type="text"
                              dir="ltr"
                              inputmode="numeric"
                              autocomplete="off"
                              placeholder="0"
                              class="form-control bnp-tm-control bnp-tm-control--unit"
                              @keypress="$ValidNumber($event, 3)"
                              @focus="IsSaveEmtiaz = 1"
                            />
                            <span class="bnp-tm-unit">ماه</span>
                          </div>
                        </div>
                        <div class="bnp-tm-field">
                          <label for="tmBeMah" class="bnp-tm-label">به ماه</label>
                          <div class="bnp-tm-unit-wrap">
                            <input
                              id="tmBeMah"
                              v-model="BeMah"
                              type="text"
                              dir="ltr"
                              inputmode="numeric"
                              autocomplete="off"
                              placeholder="0"
                              class="form-control bnp-tm-control bnp-tm-control--unit"
                              @keypress="$ValidNumber($event, 3)"
                              @focus="IsSaveEmtiaz = 1"
                            />
                            <span class="bnp-tm-unit">ماه</span>
                          </div>
                        </div>
                        <div class="bnp-tm-field">
                          <label for="tmModatBazPardakht" class="bnp-tm-label">مدت بازپرداخت</label>
                          <div class="bnp-tm-unit-wrap">
                            <input
                              id="tmModatBazPardakht"
                              v-model="ModatBazPardakht"
                              type="text"
                              dir="ltr"
                              inputmode="numeric"
                              autocomplete="off"
                              placeholder="0"
                              class="form-control bnp-tm-control bnp-tm-control--unit"
                              @keypress="$ValidNumber($event, 3)"
                              @focus="IsSaveEmtiaz = 1"
                            />
                            <span class="bnp-tm-unit">ماه</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- گزینه ۲: دریافت تسهیلات در تاریخ -->
                    <div class="bnp-tm-option" :class="{ 'bnp-tm-option--active': IsSaveEmtiaz == 2 }" @click="IsSaveEmtiaz = 2">
                      <label class="bnp-tm-option__head" for="tmOption2">
                        <input id="tmOption2" type="radio" name="tmRequestType" class="bnp-tm-radio" :value="2" v-model="IsSaveEmtiaz" />
                        <span class="bnp-tm-option__title">دریافت تسهیلات در تاریخ مشخص</span>
                      </label>
                      <p class="bnp-tm-option__desc">
                        اینجانب <b>{{ NamFam }}</b> با کد ملی <b dir="ltr">{{ CodeMeli }}</b> خواستار دریافت تسهیلات خویش در تاریخ
                        <b dir="ltr">{{ DaTarikh || '...' }}</b> می‌باشم.
                      </p>
                      <div class="bnp-tm-grid">
                        <div class="bnp-tm-field bnp-tm-date">
                          <span class="bnp-tm-label">تاریخ دریافت تسهیلات</span>
                          <date-picker :editable="true" :auto-submit="true" color="#287db4" v-model="DaTarikh" @open="IsSaveEmtiaz = 2"></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bnp-tm-footer">
                    <button type="button" class="bnp-tm-btn bnp-tm-btn--primary" :disabled="IsSending" @click="question()">
                      <i class="fas fa-paper-plane" aria-hidden="true"></i>
                      {{ IsSending ? 'در حال ارسال...' : 'ثبت درخواست' }}
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-tm-history' }"
            id="nav-tm-history"
            role="tabpanel"
            aria-labelledby="nav-tm-history-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div v-if="ListRequest.length == 0" class="bnp-tm-empty">
                  <i class="fas fa-inbox" aria-hidden="true"></i>
                  تاکنون درخواستی ثبت نکرده‌اید.
                </div>

                <ul v-else class="bnp-tm-history">
                  <li v-for="(item, index) in HistoryList" :key="index" class="bnp-tm-history__item">
                    <div class="bnp-tm-history__head">
                      <span class="bnp-tm-history__date">
                        <i class="far fa-calendar-alt" aria-hidden="true"></i>
                        <span dir="ltr">{{ item.zamanInsert }}</span>
                      </span>
                      <span class="bnp-tm-badge" :class="'bnp-tm-badge--' + StatusOf(item).tone">
                        <i :class="StatusOf(item).icon" aria-hidden="true"></i>
                        {{ StatusOf(item).text }}
                      </span>
                    </div>
                    <dl class="bnp-tm-history__grid">
                      <div>
                        <dt>از ماه</dt>
                        <dd>{{ item.azMah == null || item.azMah === '' ? '—' : item.azMah }}</dd>
                      </div>
                      <div>
                        <dt>به ماه</dt>
                        <dd>{{ item.beMah == null || item.beMah === '' ? '—' : item.beMah }}</dd>
                      </div>
                      <div>
                        <dt>مدت بازپرداخت</dt>
                        <dd>{{ item.modatBazPardakht == null ? '—' : item.modatBazPardakht }}</dd>
                      </div>
                      <div>
                        <dt>در تاریخ</dt>
                        <dd dir="ltr" class="bnp-tm-ltr">{{ item.daTarikh == null || item.daTarikh === '' ? '—' : item.daTarikh }}</dd>
                      </div>
                    </dl>
                  </li>
                </ul>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaTab from '../Tools/NetPa/NetPaTab.vue'
export default {
  components: { NetPaCard, Panel, NetPaTab },
  data() {
    return {
      NamFam: '',
      CodeMeli: '',
      AzMah: null,
      BeMah: null,
      ModatBazPardakht: null,
      DaTarikh: this.$GetJalaliDate(),
      DataAxios: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Letter/PostTaghirModatSepordeh',
        Token: this.$session.get('TokenNetPa'),
      },
      IsEnsraf: false,
      IsSending: false,
      zamanInsert: '',
      IsSaveEmtiaz: 1,
      ListRequest: [],
      activeTab: 'nav-tm-form',
    }
  },
  computed: {
    RequestTabs() {
      return [
        { id: 'nav-tm-form', title: 'ثبت درخواست' },
        { id: 'nav-tm-history', title: this.ListRequest.length ? 'سوابق درخواست (' + this.ListRequest.length + ')' : 'سوابق درخواست' },
      ]
    },
    HasPendingRequest() {
      return this.ListRequest.length > 0 && this.ListRequest[this.ListRequest.length - 1].vaziatGrp44 == null
    },
    HistoryList() {
      return this.ListRequest.slice().reverse()
    },
  },
  mounted() {
    this.NamFam = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
    this.CodeMeli = this.$session.get('UserInfoNetPa').codeMeli.trim()
    this.GetData()
  },
  methods: {
    onTabChange(id) {
      this.activeTab = id
    },
    switchTab(id) {
      this.activeTab = id
      this.$nextTick(() => {
        const link = document.getElementById(id + '-tab')
        if (link && window.$) {
          window.$(link).tab('show')
        } else if (link) {
          link.click()
        }
      })
    },
    StatusOf(item) {
      if (item.vaziatGrp44 == 7190) return { tone: 'success', icon: 'fas fa-check-circle', text: 'تأیید شد' }
      if (item.vaziatGrp44 == 7191) return { tone: 'danger', icon: 'fas fa-times-circle', text: 'رد شد' }
      return { tone: 'warning', icon: 'fas fa-hourglass-half', text: 'در حال بررسی' }
    },
    question() {
      if (this.IsSaveEmtiaz == 1) {
        if (this.AzMah == null || String(this.AzMah).trim() == '') {
          this.$mySweetDefaultTost('هشدار', 'لطفاً مدت فعلی سپرده (از ماه) را وارد کنید', 'warning', 2000)
          return
        }
        if (this.BeMah == null || String(this.BeMah).trim() == '') {
          this.$mySweetDefaultTost('هشدار', 'لطفاً مدت جدید سپرده (به ماه) را وارد کنید', 'warning', 2000)
          return
        }
        if (this.ModatBazPardakht == null || String(this.ModatBazPardakht).trim() == '') {
          this.$mySweetDefaultTost('هشدار', 'لطفاً مدت بازپرداخت را به ماه وارد کنید', 'warning', 2000)
          return
        }
      }
      if (this.IsSaveEmtiaz == 2) {
        if (!this.DaTarikh || this.DaTarikh.length != 10) {
          this.$mySweetDefaultTost('هشدار', 'لطفاً تاریخ دریافت تسهیلات را انتخاب کنید', 'warning', 2000)
          return
        }
      }
      this.$SweetQustion('اطمینان از ثبت درخواست', 'آیا از ثبت درخواست تغییر مدت سپرده اطمینان دارید؟', 'question', 'تایید ', 'انصراف', this.CodeMeli, this.SendData, this.isNotConfirmed)
    },
    SendData() {
      this.DataAxios.ArryfildValue.AzMah = this.IsSaveEmtiaz == 1 ? this.AzMah : null
      this.DataAxios.ArryfildValue.BeMah = this.IsSaveEmtiaz == 1 ? this.BeMah : null
      this.DataAxios.ArryfildValue.ModatBazPardakht = this.IsSaveEmtiaz == 1 ? this.ModatBazPardakht : null
      this.DataAxios.ArryfildValue.DaTarikh = this.IsSaveEmtiaz == 2 ? this.DaTarikh : ''

      this.DataAxios.ArryfildValue.NamFam = this.NamFam
      this.DataAxios.ArryfildValue.CodeMeli = this.CodeMeli

      this.IsSending = true
      this.$PostData(this.DataAxios)
        .then((result) => {
          if (result) {
            this.$mySweetDefaultTost('عملیات موفق', 'درخواست تغییر مدت سپرده شما با موفقیت ثبت گردید', 'success', 2000)
            this.switchTab('nav-tm-history')
          }
        })
        .finally(() => {
          this.IsSending = false
          this.GetData()
        })
    },
    isNotConfirmed() {},
    GetData() {
      var formdata = new FormData()
      formdata.append('codemeli', this.CodeMeli)
      var DataAxios_GetData = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'Letter/GetTaghirModatSepordeh',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostFormData(DataAxios_GetData).then((data) => {
        if (data.length > 0) {
          this.IsEnsraf = true
          this.zamanInsert = data[data.length - 1].zamanInsert
          this.ListRequest = data
        } else this.IsEnsraf = false
      })
    },
  },
}
</script>
<style scoped>
.bnp-tm {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-info-soft: #edf5fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-success: #05a895;
  --bnp-warning: #c48726;
  --bnp-warning-soft: #fff7e8;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;

  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

.bnp-tm-ltr {
  unicode-bidi: plaintext;
  text-align: right;
}

/* ---------- Letter head ---------- */
.bnp-tm-letter-head {
  padding-bottom: 14px;
  margin-bottom: 16px;
  text-align: center;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-tm-eyebrow {
  display: block;
  margin-bottom: 4px;
  color: var(--bnp-brand-blue);
  font-size: 12px;
  font-weight: 700;
}

.bnp-tm-letter-title {
  margin: 0;
  color: var(--bnp-brand-navy);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.6;
}

.bnp-tm-salutation {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.9;
}

.bnp-tm-salutation p {
  margin: 0;
}

.bnp-tm-salutation__to {
  color: var(--bnp-brand-navy);
  font-weight: 700;
}

/* ---------- Tiles ---------- */
.bnp-tm-tiles {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 20px;
}

.bnp-tm-tile {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-tm-tile dt {
  margin: 0 0 2px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-tm-tile dd {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  word-break: break-word;
}

.bnp-tm-section-title {
  margin-bottom: 12px;
  color: var(--bnp-brand-navy);
  font-size: 14px;
  font-weight: 800;
}

.bnp-tm-section-title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

/* ---------- Options ---------- */
.bnp-tm-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bnp-tm-option {
  padding: 14px 16px;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: #fff;
  cursor: pointer;
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.bnp-tm-option:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-tm-option--active {
  border-color: rgba(5, 184, 200, 0.55);
  background: linear-gradient(100deg, rgba(5, 184, 200, 0.05), rgba(141, 88, 164, 0.03) 60%, #fff);
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.1);
}

.bnp-tm-option__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 6px;
  cursor: pointer;
}

.bnp-tm-radio {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: var(--bnp-brand-indigo);
  cursor: pointer;
}

.bnp-tm-radio:focus-visible {
  outline: none;
  box-shadow: var(--bnp-focus-ring);
  border-radius: 50%;
}

.bnp-tm-option__title {
  color: var(--bnp-brand-navy);
  font-size: 14px;
  font-weight: 800;
}

.bnp-tm-option__desc {
  margin: 0 0 12px;
  padding-right: 28px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  line-height: 1.9;
}

.bnp-tm-option__desc b {
  color: var(--bnp-text-primary);
  font-weight: 700;
}

.bnp-tm-option:not(.bnp-tm-option--active) .bnp-tm-grid {
  opacity: 0.6;
}

/* ---------- Fields ---------- */
.bnp-tm-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding-right: 28px;
  transition: opacity var(--bnp-motion-fast) ease;
}

.bnp-tm-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bnp-tm-label {
  display: block;
  margin-bottom: 6px;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
}

.bnp-tm-unit-wrap {
  position: relative;
}

.bnp-tm-control {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 15px !important;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background-color: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-tm-control--unit {
  padding: 0 48px;
}

.bnp-tm-control:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-tm-control:focus {
  border-color: var(--bnp-focus-color);
  background-color: #fff;
  box-shadow: var(--bnp-focus-ring);
  outline: none;
}

.bnp-tm-control::placeholder {
  color: #a3adb8;
  font-weight: 400;
}

.bnp-tm-unit {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
}

/* ---------- Date picker ---------- */
.bnp-tm-date >>> .vpd-main {
  display: block;
  width: 100%;
}

.bnp-tm-date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 48px;
  overflow: hidden;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-tm-date >>> .vpd-input-group:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-tm-date >>> .vpd-input-group:focus-within {
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.bnp-tm-date >>> .vpd-input-group input,
.bnp-tm-date >>> .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 46px;
  margin: 0;
  padding: 0 12px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  direction: ltr;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

.bnp-tm-date >>> .vpd-input-group input:focus {
  outline: none;
}

.bnp-tm-date >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  margin: 0 !important;
  padding: 0 12px !important;
  color: var(--bnp-brand-blue);
  border: none;
  background: var(--bnp-info-soft);
}

/* ---------- Footer / button ---------- */
.bnp-tm-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-tm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 200px;
  min-height: 52px;
  padding: 10px 22px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  border: 0;
  border-radius: var(--bnp-radius-md);
  outline: none;
  cursor: pointer;
  transition:
    transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-tm-btn--primary {
  color: #fff;
  background: linear-gradient(110deg, var(--bnp-brand-navy), var(--bnp-brand-indigo) 58%, var(--bnp-brand-purple));
  box-shadow: var(--bnp-shadow-md);
}

.bnp-tm-btn--primary:hover:not(:disabled) {
  color: #fff;
  transform: translateY(-2px);
}

.bnp-tm-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.bnp-tm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

/* ---------- Pending notice ---------- */
.bnp-tm-pending {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid rgba(196, 135, 38, 0.3);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-warning-soft);
}

.bnp-tm-pending__icon {
  display: inline-grid;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  place-items: center;
  color: var(--bnp-warning);
  font-size: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(196, 135, 38, 0.2);
}

.bnp-tm-pending__body {
  min-width: 0;
}

.bnp-tm-pending__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #6f4a0e;
  font-size: 14px;
  font-weight: 800;
}

.bnp-tm-pending__text {
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 13px;
  line-height: 1.9;
}

/* ---------- Badge ---------- */
.bnp-tm-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  border-radius: 999px;
}

.bnp-tm-badge--success {
  color: #047a6c;
  background: rgba(5, 168, 149, 0.12);
}

.bnp-tm-badge--warning {
  color: #8a5d12;
  background: #fdebc8;
}

.bnp-tm-badge--danger {
  color: var(--bnp-danger);
  background: var(--bnp-danger-surface);
}

/* ---------- History ---------- */
.bnp-tm-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 12px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  border: 1px dashed var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
}

.bnp-tm-history {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  margin: 0;
  padding: 0 0 0 4px;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}

.bnp-tm-history__item {
  padding: 12px 14px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-tm-history__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-tm-history__date {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 700;
}

.bnp-tm-history__date i {
  color: var(--bnp-brand-blue);
}

.bnp-tm-history__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  margin: 0;
}

.bnp-tm-history__grid dt {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-tm-history__grid dd {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
}

/* ---------- Responsive ---------- */
@media (max-width: 991px) {
  .bnp-tm-history__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .bnp-tm-tiles,
  .bnp-tm-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .bnp-tm-grid,
  .bnp-tm-option__desc {
    padding-right: 0;
  }

  .bnp-tm-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-tm-option,
  .bnp-tm-grid,
  .bnp-tm-control,
  .bnp-tm-btn {
    transition: none;
  }

  .bnp-tm-btn--primary:hover:not(:disabled) {
    transform: none;
  }
}
</style>
